import { render, staticRenderFns } from "./PurchaseFormContainer.vue?vue&type=template&id=094363b4"
import script from "./PurchaseFormContainer.vue?vue&type=script&lang=js"
export * from "./PurchaseFormContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports